import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Zap, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("admin@aveselektrik.com");
  const [password, setPassword] = useState("Aves2026!");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) toast.success("Hoş geldiniz");
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#090D14]">
      {/* Left visual */}
      <div className="relative hidden lg:flex overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1716191300020-b52dec5b70a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2FsJTIwYXV0b21hdGlvbiUyMGluZHVzdHJpYWwlMjBmYWN0b3J5JTIwZXF1aXBtZW50fGVufDB8fHx8MTc5MDYyMDI2OXww&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#090D14] via-[#090D14]/70 to-transparent" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-lg bg-amber-500/20 border border-amber-500/40 grid place-items-center">
              <Zap className="w-6 h-6 text-amber-400" />
            </div>
            <div>
              <div className="font-bold text-lg text-white">AVES ELEKTRİK</div>
              <div className="text-[11px] mono uppercase tracking-[0.3em] text-amber-400/80">
                Otomasyon Sistemleri
              </div>
            </div>
          </div>

          <div className="max-w-md">
            <div className="text-xs uppercase tracking-[0.3em] mono text-amber-400 mb-3">
              Endüstriyel Finans Kontrol Paneli
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.1]">
              Cari takibinizi <span className="text-amber-400">amper</span> hassasiyetiyle yönetin.
            </h1>
            <p className="mt-4 text-slate-400 leading-relaxed">
              Vade takibi, otomatik vade farkı hesaplaması, alış-satış faturaları ve anlık nakit akışı — tek panelde.
            </p>
          </div>

          <div className="text-xs text-slate-500 mono">
            v1.0 · {new Date().getFullYear()} Aves Elektrik
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <div className="mono text-xs uppercase tracking-[0.3em] text-amber-400 mb-2">Giriş Yap</div>
            <h2 className="text-3xl font-bold tracking-tight">Hesabınıza girin</h2>
            <p className="text-sm text-slate-400 mt-2">Aves Finans yönetim panelinize devam edin.</p>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-300">E-posta</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="mt-1.5 bg-[#111723] border-white/10 h-11"
              />
            </div>
            <div>
              <Label htmlFor="pw" className="text-slate-300">Şifre</Label>
              <Input
                id="pw"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="mt-1.5 bg-[#111723] border-white/10 h-11"
              />
            </div>
          </div>

          {error && (
            <div className="rounded-lg border border-red-500/30 bg-red-500/10 text-red-200 text-sm px-4 py-2.5" data-testid="login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={busy}
            data-testid="login-submit-btn"
            className="w-full h-11 bg-amber-500 hover:bg-amber-400 text-black font-semibold"
          >
            <LogIn className="w-4 h-4 mr-2" />
            {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>

          <div className="text-center text-sm text-slate-400">
            Hesabınız yok mu?{" "}
            <Link to="/register" className="text-amber-400 hover:underline" data-testid="link-register">
              Kayıt olun
            </Link>
          </div>

          <div className="rounded-lg border border-amber-500/20 bg-amber-500/5 p-3 text-xs text-slate-400">
            <div className="mono uppercase tracking-widest text-amber-400/80 mb-1">Demo Hesap</div>
            admin@aveselektrik.com · Aves2026!
          </div>
        </form>
      </div>
    </div>
  );
}
